// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"78f70648","787":"fb839980"}[chunkId] + ".chunk.js";
};